import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI, { MenuItem } from "element-ui";
import "./assets/css/element-variables.scss";
// import 'element-ui/lib/theme-chalk/index.css'
import "./assets/css/global.css";
import "./assets/css/index.scss";
import "pdfh5/css/pdfh5.css";

import config from "@/config/api.js";
import axios from "@/assets/js/httpUtil.js";
import valid from "@/assets/js/valid";
import { isMoblie } from "@/assets/js/until";
import Vconsole from "vconsole";
import * as filters from "@/assets/js/filters.js";
import * as directives from "@/assets/js/directives";
import { saveAs } from "file-saver";
import MetaInfo from "vue-meta-info";
Vue.use(MetaInfo); // 动态设置meta

// 引入echarts
import echarts from "echarts";
import "echarts/dist/extension/dataTool.js";
import "echarts-wordcloud";
require("./assets/js/global.js");
require("./assets/js/mobile.js");
Vue.use(MenuItem);
if (isMoblie()) {
  if (process.env.VUE_APP_ENV !== "prod") {
    // 测试和开发打开，生产不能打开
    let vConsole = new Vconsole();
    Vue.use(vConsole);
  }
}

Vue.use(ElementUI);
Vue.prototype.$echarts = echarts;
Vue.prototype._valid = valid;
Vue.config.productionTip = false;
console.log("VUE_APP_ENV:" + process.env.VUE_APP_ENV);

import Msgbox from "./components/msgbox/index";
Vue.prototype.$msgbox = Msgbox.install;

import {
  Button,
  Toast,
  Empty,
  Cell,
  List,
  Uploader,
  ImagePreview,
  PullRefresh,
  Lazyload,
  Popup,
  Overlay,
  Icon,
} from "vant";
Vue.use(Button)
  .use(Toast)
  .use(Empty)
  .use(Cell)
  .use(List)
  .use(Uploader)
  .use(ImagePreview)
  .use(PullRefresh)
  .use(Lazyload)
  .use(Popup)
  .use(Overlay)
  .use(Icon);
// 注册时可以配置额外的选项
Vue.use(Lazyload, {
  lazyComponent: true,
});
// 添加过滤器
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});
//添加指令
Object.keys(directives).forEach((key) => {
  Vue.use(directives[key]);
});

// 接口部分
Vue.prototype.request = Vue.prototype.axios = axios;
Vue.prototype.getApiUrl = config.getApiUrl;
Vue.prototype.getApiUrlE = config.getApiUrlE;

window.vm = new Vue({
  metaInfo() {
    return {
      meta: this.metaData,
    };
  },
  data: {
    token: "",
    username: "", //用户名
    authMap: {},
    breadList: [],
    showName: true, // 显示隐藏右上角用户名
    showPage: true, // 显示页面
    metaData: [
      {
        name: "viewport",
        content: "width=device-width,initial-scale=1.0",
      },
    ],
    whiteUrlList: [
      "identify",
      "body-report/list",
      "body-report/detail",
      "body-report/import",
      "health-archive",
    ], // 白名单
  },
  methods: {
    // 缓存页面数据
    savePageCache(searchCache, key = "searchCache") {
      sessionStorage.setItem(key, JSON.stringify(searchCache));
    },
    getPageCache(key = "searchCache") {
      let name = sessionStorage.getItem(key);
      return name ? JSON.parse(name) : "";
    },
    removeCache(key = "searchCache") {
      sessionStorage.removeItem(key);
    },
    optionProcess(option) {
      for (var i in option) {
        var item = option[i];
        if (!item && item !== 0 && item !== false) {
          delete option[i];
        }
      }
      return option;
    },
    setUserInfo() {
      let username = window.$getCookie("username");
      let token = window.$getCookie("token");
      if (token && username) {
        this.username = username;
        this.token = token;
      }
    },
    // 导出文件
    exportFile(apiUrl, params, fileN = "", format = ".xls") {
      let data = {
        ...params,
      };
      let xhr = new XMLHttpRequest();
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
          let fileName = fileN;
          let res = "response" in xhr ? xhr.response : xhr.responseText;
          let type = "application/vnd.ms-excel";
          saveAs(
            new Blob([res], {
              type: type,
            }),
            fileName + format
          );
        }
      };
      var str = "";
      Object.keys(data).forEach((item) => {
        str += `${item}=${data[item]}&`;
      });
      let query = JSON.stringify(data) != "{}" ? str.slice(0, -1) : "";
      xhr.open("get", apiUrl + "?" + query);
      xhr.setRequestHeader("token", this.$root.$data.token);
      xhr.setRequestHeader("Content-type", "application/json");
      xhr.responseType = "arraybuffer";
      xhr.send(null);
    },
    // 首次进入登录校验
    async checkLogin() {
      let url = window.location.href;
      for (let i in this.whiteUrlList) {
        if (url.indexOf(this.whiteUrlList[i]) > -1) return;
      }
      let res = await this.axios.get(this.getApiUrl("loginCheck"), {
        params: {},
      });
    },
    // 判断是否为移动端
    isMoblie() {
      let url = window.location.href;
      for (let i in this.whiteUrlList) {
        if (url.indexOf(this.whiteUrlList[i]) > -1) {
          this.metaData = [
            {
              name: "viewport",
              content:
                "width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no,viewport-fit=cover",
            },
          ];
          break;
        }
      }
    },
  },
  watch: {
    showPage(e) {
      this.removeCache("supplierQuery");
      if (!e) this.$nextTick(() => (this.showPage = true));
    },
  },
  created() {
    // 判断是否为移动端
    this.isMoblie();
    this.checkLogin();
    this.setUserInfo();
  },
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
